<template>
    <div v-if="model && form">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Data inicial"
                            end-label="Data final"
                            v-model="model.periodo"
                            :start-validations="{ required: true }"
                            :end-validations="{ required: true }"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Motorista"
                            :options="form.motoristas"
                            text-field="nome"
                            value-field="id"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.motorista"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Município"
                            :options="form.municipios"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.municipio"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Local"
                            :options="form.destinos"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.destino"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Status"
                            :options="form.status"
                            show-default-option
                            default-option-text="Todos"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Veículo"
                            :options="form.veiculos"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.veiculo"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Motivo"
                            :options="form.motivos"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.motivo"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Protocolo"
                            v-model="model.protocolo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="search"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="items.length"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <div v-for="grupo in agrupamentoDeViagens" :key="`${grupo.motorista}-${grupo.municipio}-${grupo.status}-${grupo.veiculo}-${grupo.horario_saida}`">
                <rkm-area
                no-margin-top
                :title="`Motorista: ${grupo.motorista}`"
                type="fieldset"
                >
                    <rkm-table :fields="fields" :items="grupo.viagens">
                        <template v-slot:cell(data)="{ item }">
                        {{ item.data | formatDate }}
                        </template>
                    </rkm-table>

                    <rkm-area title="Totalizadores">
                        <rkm-table
                            :hide-filters="true"
                            :hide-pagination="true"
                            :items="[totalizadoresCalculados(grupo.viagens)]"
                            :fields="totais"
                        >
                            <template v-slot:cell(diarias)="{ item }">
                            R${{ item.diarias.toFixed(2) }}
                            </template>
                        </rkm-table>
                    </rkm-area>
                </rkm-area>
            </div>
        </rkm-area>

        <rkm-area
            title="Total Geral"
            type="fieldset"
            no-margin-top
            v-if="total != null"
        >
            <rkm-row>
                <rkm-col cols="4">
                    Total de viagens no período
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total.viagens }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="4">
                    Total pago de diária no período
                    <rkm-alert color="secondary">
                        <strong>
                            R${{ total.diarias.toFixed(2) }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="4">
                    Total de pacientes no período
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total.pacientes }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    Total de acompanhantes no período
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total.acompanhantes }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="4">
                    Total de passageiros no período
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total.passageiros }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="4">
                    % total de acompanhantes no período
                    <rkm-alert color="secondary">
                        <strong>
                            {{ total.porcentagem }}%
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
        <ModalPreferenciaImpressao ref="ModalPreferenciaImpressao" @orientation="updateOrientation"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file } from '@/mixins'
import moment from 'moment'
import formats from '@/filters/formats'
import ModalPreferenciaImpressao from '@/components/geral/impressao/Modal'

export default {
    filters: {
        formatDate: formats.formatDate,
    },
    components:{ ModalPreferenciaImpressao },
    watch: {
        model: {
            deep: true,
            handler() {
                this.items = []
                this.motoristas = []
                this.total = null
            }
        },
        'model.perido.start': function() {
            if(this.model.periodo.end) {
                this.getMotoristas()
                this.getMunicipios()
                this.getDestinos()
                this.getVeiculos()
                this.getMotivos()
            }
        },
        'model.periodo.end': function() {
            if(this.model.periodo.start) {
                this.getMotoristas()
                this.getMunicipios()
                this.getDestinos()
                this.getVeiculos()
                this.getMotivos()
            }
        },
        'model.motorista': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getMunicipios()
                this.getDestinos()
                this.getVeiculos()
                this.getMotivos()
            }
        },
        'model.municipio': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getDestinos()
                this.getVeiculos()
                this.getMotivos()
            }
        },
        'model.destino': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getVeiculos()
                this.getMotivos()
            }
        },
        'model.veiculo': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getMotivos()
            }
        },
    },
    computed: {
        agrupamentoDeViagens() {
            const grupos = this.items.reduce((acc, viagem) => {
            const key = `${viagem.motorista}-${viagem.municipio}-${viagem.status}-${viagem.veiculo}-${viagem.horario_saida || 'Sem horário'}`;

            if (!acc[key]) {
                acc[key] = {
                motorista: viagem.motorista,
                municipio: viagem.municipio,
                status: viagem.status,
                veiculo: viagem.veiculo,
                horario_saida: viagem.horario_saida,
                viagens: [],
                };
            }

            acc[key].viagens.push(viagem);

            return acc;
            }, {});

            return Object.values(grupos).sort((a, b) => {
                if (a.motorista < b.motorista) return -1;
                if (a.motorista > b.motorista) return 1;
                return 0;
            });
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        selectedAll() {
            return this.selectedCols.length == 13
        },
    },
    created() {
        this.repositories = {
            relatorioEstatistico: this.getConectaSusRepository('transportePaciente.relatorioEstatistico'),
            impressao: this.getConectaSusRepository('impressao.transportePaciente'),
            exportacao: this.getConectaSusRepository('exportacao.transportePaciente'),
        }
        this.load()
    },
    data() {
        return {
            model: null,
            form: null,
            items: [],
            motoristas: [],
            total: null,
            orientation: '',
            selectedCols: [
                'municipio',
                'status',
                'veiculo',
                'data',
                'destino',
                'paciente',
                'motivo',
                'horarioSaida',
                'horarioChegada'
            ],
            totais: [
                {
                    key: 'viagens',
                    label: 'Total de viagens',
                    sortable: true,
                },
                {
                    key: 'passageiros',
                    label: 'Total de passageiros',
                    sortable: true,
                },
                {
                    key: 'diarias',
                    label: 'Total de diárias',
                    sortable: true,
                },
            ],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    fixed: true
                },
                {
                    key: 'municipio',
                    label: 'Município',
                    sortable: true,
                },
                {
                    key: 'destino',
                    label: 'Destino',
                    sortable: true,
                },
                {
                    key: 'veiculo',
                    label: 'Veículo',
                    sortable: true,
                },
                {
                    key: 'capacidade',
                    label: 'Capacidade',
                    sortable: true,
                },
                {
                    key: 'prontuario',
                    label: 'Prontuário',
                    sortable: true,
                },
                {
                    key: 'paciente',
                    label: 'Paciente',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'acompanhante',
                    label: 'Acompanhante',
                    sortable: true,
                },
                {
                    key: 'motivo',
                    label: 'Motivo',
                    sortable: true,
                },
                {
                    key: 'horarioSaida',
                    label: 'Horário de saída',
                    sortable: true,
                },
                {
                    key: 'horarioChegada',
                    label: 'Horário de chegada',
                    sortable: true,
                },
                {
                    key: 'diaria',
                    label: 'Diária',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                },
            ],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.relatorioEstatistico.index()
                .then(({data}) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.$refs.Form.validate().then(valid => {
                if(valid) {
                    this.setLoading()
                    this.repositories.relatorioEstatistico.list({
                        'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                        'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                        'motorista': this.model.motorista,
                        'municipio': this.model.municipio,
                        'destino': this.model.destino,
                        'status': this.model.status,
                        'veiculo': this.model.veiculo,
                        'motivo': this.model.motivo,
                        'prontuario': this.model.prontuario,
                        'protocolo': this.model.protocolo
                    })
                        .then(({data}) => {
                            this.items = data.viagens;
                            this.total = data.total
                            this.motoristas = data.motoristas
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        reset() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.motorista = null
            this.model.municipio = null
            this.model.destino = null
            this.model.status = null
            this.model.veiculo = null
            this.model.motivo = null
            this.model.prontuario = null
            this.items = []
            this.motoristas = []
            this.total = null
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.$refs.ModalPreferenciaImpressao.open();
            this.$refs.ModalPreferenciaImpressao.$once('completed', () => {
                this.setLoading()
                this.repositories.impressao.relatorioEstatistico(this.prepareDataWithColumns())
                    .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioEstatistico(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {
            const data = this.prepareData()
            data.selectedCols = this.fields.map(f => {
                return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }
            })
            return data
        },
        prepareData() {
            const data = this.clone(this.model)
            data.dataInicial = moment(data.periodo.start).format('Y-M-D')
            data.dataFinal = moment(data.periodo.end).format('Y-M-D')
            data.filtroMotorista = data.motorista ? this.form.motoristas.find(m => m.id == data.motorista).nome : 'Todos'
            data.filtroMunicipio = data.municipio ? this.form.municipios.find(m => m.id == data.municipio).nome : 'Todos'
            data.filtroDestino = data.destino ? this.form.destinos.find(d => d.id == data.destino).descricao : 'Todos'
            data.filtroStatus = data.status ? this.form.status.find(s => s.id == data.status).descricao : 'Todos'
            data.filtroVeiculo = data.veiculo ? this.form.veiculos.find(v => v.id == data.veiculo).descricao : 'Todos'
            data.filtroMotivo = data.motivo ? this.form.motivos.find(m => m.id == data.motivo).descricao : 'Todos'
            data.orientation = this.orientation
            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        },
        getMotoristas() {
            this.setLoading()
            this.repositories.relatorioEstatistico.getMotoristas({
                'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                'status': this.model.status
            })
                .then(({data}) => {
                    this.form.motoristas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getMunicipios() {
            this.setLoading()
            this.repositories.relatorioEstatistico.getMunicipios({
                'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                'motorista': this.model.motorista,
                'status': this.model.status
            })
                .then(({data}) => {
                    this.form.municipios = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getDestinos() {
            this.setLoading()
            this.repositories.relatorioEstatistico.getDestinos({
                'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                'motorista': this.model.motorista,
                'municipio': this.model.municipio,
                'status': this.model.status
            })
                .then(({data}) => {
                    this.form.destinos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getVeiculos() {
            this.setLoading()
            this.repositories.relatorioEstatistico.getVeiculos({
                'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                'motorista': this.model.motorista,
                'municipio': this.model.municipio,
                'destino': this.model.destino,
                'status': this.model.status
            })
                .then(({data}) => {
                    this.form.veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getMotivos() {
            this.setLoading()
            this.repositories.relatorioEstatistico.getMotivos({
                'data_inicial': moment(this.model.periodo.start).format('Y-M-D'),
                'data_final': moment(this.model.periodo.end).format('Y-M-D'),
                'motorista': this.model.motorista,
                'municipio': this.model.municipio,
                'destino': this.model.destino,
                'veiculo': this.model.veiculo,
                'status': this.model.status
            })
                .then(({data}) => {
                    this.form.motivos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        totalizadoresCalculados(viagens) {
            const totalDiarias = viagens.reduce((acc, viagem) => acc + parseFloat(viagem.diaria), 0);
            const totalViagens = viagens.length;
            const totalPassageiros = viagens.reduce((acc, viagem) => acc + viagem.acompanhante + 1, 0);
            const totalAcompanhantes = viagens.reduce((acc, viagem) => acc + viagem.acompanhante, 0);

            return {
                motorista: viagens[0]?.motorista || 'Desconhecido',
                viagens: totalViagens,
                diarias: totalDiarias,
                passageiros: totalPassageiros,
                acompanhantes: totalAcompanhantes,
            };
        },
        updateOrientation(value) {
            this.orientation = value;
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
}
</script>